// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferData {
  /** Адрес **/
  address: string;
  /** Тип сделки **/
  dealType: EDealType;
  /** Тип объекта **/
  offerType: EOfferType;
  /** Цена **/
  price?: TOfferData_Price;
}

export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EOfferType {
  /** квартиры **/
  'Flat' = 'flat',
  /** загородка **/
  'Suburban' = 'suburban',
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** новостройки **/
  'Newobject' = 'newobject',
}
export type TOfferData_Price = null | number;
